// Map the heading to within -180 - 180
export const mapHeading = (heading) => {
    let ret = (heading + 180) % 360
    if (ret < 0) {
        ret += 360
    }
    ret -= 180
    return ret
}

export const generatePositionStyle = (targetRect, panelRect, contentRect, docHeight, docWidth) => {
    const spaceBelowOnScreen = docHeight - targetRect.bottom
    const spaceBelowOnCanvas = contentRect.bottom - targetRect.bottom
    const spaceAboveOnScreen = targetRect.top
    const spaceAboveOnCanvas = targetRect.top - contentRect.top

    const pad = 16 // 16px = 1rem
    const style = { opacity: 1 }
    // Place it 1rem off and then animate it place using margin
    const animationOffset = -16

    const toolHeight = 80 // rotateHeight
    const toolWidth = 200 // rotateWidth
    const panelHeight = panelRect.height
    const panelWidth = panelRect.width
    const maxPanelWidth = Math.max(panelWidth, toolWidth) + pad

    // Start with vertical placement
    if (spaceBelowOnCanvas >= panelHeight + pad && spaceBelowOnScreen >= panelHeight + toolHeight + pad) {
        // Try to place it under the target, but on the canvas and with space to open the tool
        style.top = targetRect.bottom + pad - animationOffset
        style.marginTop = animationOffset
    } else if (spaceAboveOnCanvas >= panelHeight + pad && spaceAboveOnScreen >= panelHeight + toolHeight + pad) {
        // Try to place above the target, but on the canvas and with space to open the tool
        style.top = 'initial' // eslint-disable-line i18next/no-literal-string
        style.bottom = docHeight - targetRect.top + pad - animationOffset
        style.marginBottom = animationOffset
    }

    // Continue with horizontal placement

    if (style.top) {
        // We were able to place it above or below the target

        // Space between the left side of the target and the right edge of the canvas
        const spaceRight = contentRect.right - targetRect.left
        if (spaceRight >= maxPanelWidth) {
            // Place it left aligned with the target, open to the right
            // Don't let the panel touch the edge of the canvas
            style.left = Math.max(targetRect.left, contentRect.left + pad)
        } else {
            style.left = 'initial' // eslint-disable-line i18next/no-literal-string
            // Place it right aligned with the target, open to the left
            // Don't let the panel touch the edge of the canvas
            style.right = Math.max(docWidth - targetRect.right, pad)
        }
    } else {
        // We were unable to place it above or below, let's try placing it to the side
        const spaceLeft = targetRect.left - contentRect.left
        const spaceRight = contentRect.right - targetRect.right
        const placeLeft = spaceLeft >= maxPanelWidth && spaceLeft >= spaceRight
        const placeRight = spaceRight >= maxPanelWidth
        if (placeLeft || placeRight) {
            // We can fit the panel to the side
            if (placeLeft) {
                style.left = 'initial' // eslint-disable-line i18next/no-literal-string
                style.right = docWidth - targetRect.left
            } else {
                style.left = targetRect.right + pad
            }
            // Align with the top of the target, but at least a pad away from the edge
            style.top = Math.max(targetRect.top, contentRect.top + pad)
        } else {
            // We were unable to place it above or below or to either side
            // so we'll place it on top of the item

            // Center the panel with the target
            style.left = targetRect.left + targetRect.width / 2 - panelWidth / 2

            // Don't let the panel+tool go off-screen
            const onScreenBound = docHeight - pad - toolHeight - panelHeight
            // Don't let the panel go off-canvas
            const onCanvasBound = targetRect.bottom - panelHeight - pad
            style.top = Math.min(onScreenBound, onCanvasBound)
        }
    }
    return style
}
